import { SET_BLOGS, SET_BLOG } from "../actionTypes"

const initialState = {
  blogsObject: {},
  blogs: [],
  blog: {}
}

const blogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BLOGS:
      return {
        ...state,
        blogs: action.blogs.data,
        blogsObject: action.blogs
      }
    case SET_BLOG:
      return {
        ...state,
        blog: action.blog,
      }
    default:
      return state
  }
}

export default blogsReducer